module.exports = __webpack_public_path__ + "60a79552f1e634e318c124fedef1724c.svg";